import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";

export default function JsxSyntaxHighlighter(props) {
  return (
    <SyntaxHighlighter
      language="tsx"
      codeTagProps={{
        style: {
          fontFamily: "Consolas,Liberation Mono,Menlo,monospace",
        },
      }}
      customStyle={{
        overflow: "auto",
        maxWidth: "calc(max(100vw - 34rem, 30rem))",
        maxHeight: "80vh",
      }}
      style={darcula}
      {...props}
    />
  );
}
